export default __webpack_public_path__ + "static/media/cif-es.bba9874f.svg";